import moment from 'moment/moment';
import { useSelectDatePicker } from '@bbkAdminRedux/rtkq/datepicker-persist.slice';

export const useGetGroupByPeriod = () => {
  const { startDate: start, endDate: end } = useSelectDatePicker();

  // .diff truncates the decimal places, returning an integer
  const weeks = moment.utc(end).diff(moment.utc(start), 'weeks');

  // up to 14 days
  if (weeks < 2) return 'day';

  // up to 1 quarter. Longest quarter is 13.1 weeks
  if (weeks < 14) return 'week';

  // up to 1 year
  if (weeks < 53) return 'month';

  return 'quarter';
};
